import { FC, useState } from "react";
import { CardContext } from "./context";

const CardProvider: FC = ({ children }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (value: boolean) => {
    setIsFocused(value);
  };

  const context = {
    isFocused,
    handleFocus
  };

  return (
    <CardContext.Provider value={context}>{children}</CardContext.Provider>
  );
};

export default CardProvider;
